/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const clinicHealthCheckedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicHealthComponentsItemDaysItemDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const clinicHealthComponentsItemDaysItemDownMinutesMin = 0
export const clinicHealthComponentsItemDaysItemDownMinutesMax = 9007199254740991

export const clinicHealthComponentsItemDaysItemIncidentsItemEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicHealthComponentsItemDaysItemIncidentsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicHealthComponentsItemDaysItemIncidentsItemStartedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicHealthComponentsItemDaysItemUnknownMinutesMin = 0
export const clinicHealthComponentsItemDaysItemUnknownMinutesMax = 9007199254740991

export const clinicHealthComponentsItemDaysItemUpMinutesMin = 0
export const clinicHealthComponentsItemDaysItemUpMinutesMax = 9007199254740991

export const clinicHealthComponentsItemDaysItemUptimeOneMin = 0
export const clinicHealthComponentsItemDaysItemUptimeOneMax = 1

export const clinicHealthComponentsItemSinceOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicHealthComponentsItemUptimeOneMin = 0
export const clinicHealthComponentsItemUptimeOneMax = 1

export const clinicHealthLastHeartbeatAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicHealthOverallDaysItemDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const clinicHealthOverallDaysItemUptimeOneMin = 0
export const clinicHealthOverallDaysItemUptimeOneMax = 1

export const clinicHealthOverallUptimeOneMin = 0
export const clinicHealthOverallUptimeOneMax = 1

export const ClinicHealth = zod.object({
  checkedAt: zod.union([zod.iso.datetime({ offset: true }).regex(clinicHealthCheckedAtOneRegExp), zod.null()]),
  components: zod.array(
    zod.object({
      component: zod.enum(['pf_keeper_app', 'pf_session']),
      days: zod.array(
        zod.object({
          date: zod.string().regex(clinicHealthComponentsItemDaysItemDateRegExp),
          downMinutes: zod
            .int()
            .min(clinicHealthComponentsItemDaysItemDownMinutesMin)
            .max(clinicHealthComponentsItemDaysItemDownMinutesMax),
          incidents: zod.array(
            zod.object({
              endedAt: zod.union([
                zod.iso
                  .datetime({ offset: true })
                  .regex(clinicHealthComponentsItemDaysItemIncidentsItemEndedAtOneRegExp),
                zod.null(),
              ]),
              id: zod.uuid().regex(clinicHealthComponentsItemDaysItemIncidentsItemIdRegExp),
              startedAt: zod.iso
                .datetime({ offset: true })
                .regex(clinicHealthComponentsItemDaysItemIncidentsItemStartedAtRegExp),
              title: zod.string(),
            }),
          ),
          level: zod.enum(['ok', 'minor', 'major', 'no_data']),
          unknownMinutes: zod
            .int()
            .min(clinicHealthComponentsItemDaysItemUnknownMinutesMin)
            .max(clinicHealthComponentsItemDaysItemUnknownMinutesMax),
          upMinutes: zod
            .int()
            .min(clinicHealthComponentsItemDaysItemUpMinutesMin)
            .max(clinicHealthComponentsItemDaysItemUpMinutesMax),
          uptime: zod.union([
            zod
              .number()
              .min(clinicHealthComponentsItemDaysItemUptimeOneMin)
              .max(clinicHealthComponentsItemDaysItemUptimeOneMax),
            zod.null(),
          ]),
        }),
      ),
      since: zod.union([
        zod.iso.datetime({ offset: true }).regex(clinicHealthComponentsItemSinceOneRegExp),
        zod.null(),
      ]),
      state: zod.enum(['up', 'degraded', 'down', 'unknown']),
      uptime: zod.union([
        zod.number().min(clinicHealthComponentsItemUptimeOneMin).max(clinicHealthComponentsItemUptimeOneMax),
        zod.null(),
      ]),
    }),
  ),
  degradedReason: zod.string().nullable(),
  lastHeartbeatAt: zod.union([
    zod.iso.datetime({ offset: true }).regex(clinicHealthLastHeartbeatAtOneRegExp),
    zod.null(),
  ]),
  overall: zod.object({
    days: zod.array(
      zod.object({
        date: zod.string().regex(clinicHealthOverallDaysItemDateRegExp),
        level: zod.enum(['ok', 'minor', 'major', 'no_data']),
        uptime: zod.union([
          zod.number().min(clinicHealthOverallDaysItemUptimeOneMin).max(clinicHealthOverallDaysItemUptimeOneMax),
          zod.null(),
        ]),
      }),
    ),
    uptime: zod.union([
      zod.number().min(clinicHealthOverallUptimeOneMin).max(clinicHealthOverallUptimeOneMax),
      zod.null(),
    ]),
  }),
  pfKeeperApp: zod.enum(['up', 'degraded', 'down', 'unknown']),
  pfSession: zod.enum(['up', 'degraded', 'down', 'unknown']),
  status: zod.enum(['healthy', 'degraded', 'down', 'unknown', 'not_connected', 'inactive']),
})

export type ClinicHealth = zod.input<typeof ClinicHealth>
export type ClinicHealthOutput = zod.output<typeof ClinicHealth>
